import { IAuth } from 'meta/auth'

export const initialState: IAuth = {
  pending: false,
  token: undefined,
  userData: undefined,
}
